<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="用户邮箱">
            <el-input v-model="formInline.userEmail" placeholder="用户邮箱" clearable />
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model="formInline.userName" placeholder="用户姓名" clearable />
          </el-form-item>
          <el-form-item label="产品标题">
            <el-input v-model="formInline.productTitle" placeholder="产品标题" clearable />
          </el-form-item>
          <el-form-item label="发送状态">
            <el-select clearable v-model="formInline.sendStatus" placeholder="请选择" style="width: 200px">
              <el-option
                  v-for="item in sendStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startDate"
                type="date"
                placeholder="创建时间"
                clearable
            />
            -
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endDate"
                type="date"
                placeholder="创建时间"
                clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
        >
          <el-table-column
              label="用户邮箱"
              min-width="80"
              prop="userEmail"
          ></el-table-column>
          <el-table-column
              label="用户姓名"
              min-width="100"
              prop="userName"
          ></el-table-column>
          <el-table-column
              label="产品标题"
              min-width="100"
              prop="productTitle"
          ></el-table-column>
          <el-table-column
              label="产品图片"
              min-width="100"
              prop="productImage"
          >
            <template #default="scope">
              <el-image
                  v-if="scope.row.productImage"
                  class="product-image"
                  :src="scope.row.productImage"
                  :preview-src-list="[scope.row.productImage]"
                  fit="contain"
                  preview-teleported
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
              label="产品连接"
              min-width="100"
              prop="productLink"
          >
            <template #default="scope">
              <el-link v-if="scope.row.productLink" :href="scope.row.productLink" target="_blank" type="primary">查看产品</el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
              label="发送状态"
              min-width="100"
              prop="sendStatus"
          >
            <template #default="scope">
              <el-tag :type="isSendSuccess(scope.row.sendStatus) ? 'success' : 'danger'">
                {{ isSendSuccess(scope.row.sendStatus) ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              label="失败详情"
              min-width="260"
              prop="errorMessage"
              show-overflow-tooltip
          >
            <template #default="scope">
              <span v-if="isSendFailed(scope.row.sendStatus)" class="error-message">{{ scope.row.errorMessage || '未返回详细错误信息' }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
              label="创建时间"
              min-width="100"
              prop="createdAt"
          ></el-table-column>
<!--          <el-table-column-->
<!--              label="邮件模板"-->
<!--              min-width="100"-->
<!--          >-->
<!--            <template #default="scope">-->
<!--              <el-button link type="primary" :disabled="!scope.row.emailContent" @click="showMailPreview(scope.row)">预览邮件</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <el-dialog v-model="previewVisible" title="邮件模板预览" width="40%" destroy-on-close>
      <iframe v-if="previewHtml" class="mail-preview" :srcdoc="previewHtml" title="邮件模板预览"></iframe>
    </el-dialog>

  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElTable,ElSelect,ElOption, ElTableColumn,ElDatePicker,ElPagination,ElImage,ElLink,ElTag,ElDialog} from "element-plus";
import {getShopifyProdOriList} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";

export default {
  name: "shopifyProdOri",
  mixins:[DynamicHeightMixin],
  components: {ElForm,ElFormItem,ElButton,ElTable,ElDatePicker,
    ElSelect,ElOption,ElImage,ElLink,ElTag,ElDialog,
    ElTableColumn,ElPagination},
  data(){
    return{
      formInline:{userEmail:"",userName:"",productTitle:"",sendStatus:"",startDate:"",endDate:""},
      tableData:[],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
      previewVisible:false,
      previewHtml:"",
      sendStatusList:[
        {label:"成功",key:"SUCCESS",value:"成功"},
        {label:"失败",key:"FAILED",value:"失败"}
      ]
    }
  },
  beforeMount() {
    this.getOrderList();
  },
  methods:{
    onSubmit(){
      this.currentPage = 1
      this.getOrderList()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getOrderList();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getOrderList();
    },
    getOrderList(){
      this.tableData = []
      getShopifyProdOriList({...this.formInline, currentPage:this.currentPage, pageSize:this.pageSize}).then(res=>{
        const page = res.data || {}
        this.tableData = page.data || []
        this.currentPage = page.currentPage || this.currentPage
        this.pageSize = page.pageSize || this.pageSize
        this.pageTotal = page.total || 0
      }).catch(res=>{
        console.log(res)
      })
    },
    showMailPreview(row){
      this.previewHtml = row.emailContent || ""
      this.previewVisible = true
    },
    isSendSuccess(status) {
      return status === "成功"
    },
    isSendFailed(status) {
      return status === "失败"
    }
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ellipsis-fallback {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.product-image {
  width: 72px;
  height: 54px;
  cursor: pointer;
}
.mail-preview {
  width: 100%;
  height: min(78vh, 900px);
  min-height: 1000px;
  border: 0;
}
.error-message {
  color: #f56c6c;
}
</style>
